module.exports = "/assets/newsletter/bg_mobile_center.png?U68gJTI";